import {
  ADD_VENDOR_FAILURE,
  ADD_VENDOR_REQUEST,
  ADD_VENDOR_SUCCESS,
  CLEAR_VENDOR_DELETE_SUCCESS,
  DELETE_VENDOR_FAILURE,
  DELETE_VENDOR_REQUEST,
  DELETE_VENDOR_SUCCESS,
  FETCH_ALL_VENDORS_FAILURE,
  FETCH_ALL_VENDORS_REQUEST,
  FETCH_ALL_VENDORS_SUCCESS,
  FETCH_CUSTOMERS_BY_VENDOR_FAILURE,
  FETCH_CUSTOMERS_BY_VENDOR_REQUEST,
  FETCH_CUSTOMERS_BY_VENDOR_SUCCESS,
  FETCH_VENDOR_DETAILS_FAILURE,
  FETCH_VENDOR_DETAILS_REQUEST,
  FETCH_VENDOR_DETAILS_SUCCESS,
  FETCH_VENDORS_FAILURE,
  FETCH_VENDORS_REQUEST,
  FETCH_VENDORS_SUCCESS,
  RESET_VENDOR_STATE,
  UPDATE_VENDOR_APPROVAL_STATUS_FAILURE,
  UPDATE_VENDOR_APPROVAL_STATUS_REQUEST,
  UPDATE_VENDOR_APPROVAL_STATUS_SUCCESS,
  UPDATE_VENDOR_FAILURE,
  UPDATE_VENDOR_REQUEST,
  UPDATE_VENDOR_SUCCESS
} from "../types/vendorTypes";

export const fetchVendorsRequest = (payload) => ({
  type: FETCH_VENDORS_REQUEST,
  payload
});

export const fetchVendorsSuccess = (vendors) => ({
  type: FETCH_VENDORS_SUCCESS,
  payload: vendors
});

export const fetchVendorsFailure = (error) => ({
  type: FETCH_VENDORS_FAILURE,
  payload: error
});
export const fetchAllVendorsRequest = () => ({
  type: FETCH_ALL_VENDORS_REQUEST
});
export const fetchAllVendorSuccess = (payload) => ({
  type: FETCH_ALL_VENDORS_SUCCESS,
  payload
});
export const fetchAllVendorFailure = (payload) => ({
  type: FETCH_ALL_VENDORS_FAILURE,
  payload
});
export const addVendorRequest = (vendorData) => ({
  type: ADD_VENDOR_REQUEST,
  payload: vendorData
});

export const addVendorSuccess = (message) => ({
  type: ADD_VENDOR_SUCCESS,
  payload: message
});

export const addVendorFailure = (error) => ({
  type: ADD_VENDOR_FAILURE,
  payload: error
});

export const updateVendorRequest = (vendorData) => ({
  type: UPDATE_VENDOR_REQUEST,
  payload: vendorData
});

export const updateVendorSuccess = (data) => ({
  type: UPDATE_VENDOR_SUCCESS,
  payload: data
});

export const updateVendorFailure = (error) => ({
  type: UPDATE_VENDOR_FAILURE,
  payload: error
});

export const deleteVendorRequest = (vendorId) => ({
  type: DELETE_VENDOR_REQUEST,
  payload: vendorId
});

export const deleteVendorSuccess = (vendorId) => ({
  type: DELETE_VENDOR_SUCCESS,
  payload: vendorId
});

export const deleteVendorFailure = (error) => ({
  type: DELETE_VENDOR_FAILURE,
  payload: error
});

export const fetchVendorDetailsRequest = (vendorId) => ({
  type: FETCH_VENDOR_DETAILS_REQUEST,
  payload: vendorId
});

export const fetchVendorDetailsSuccess = (vendorData) => ({
  type: FETCH_VENDOR_DETAILS_SUCCESS,
  payload: vendorData
});

export const fetchVendorDetailsFailure = (error) => ({
  type: FETCH_VENDOR_DETAILS_FAILURE,
  payload: error
});

export const resetVendorState = () => ({
  type: RESET_VENDOR_STATE
});

export const clearVendorDeleteSuccess = () => ({
  type: CLEAR_VENDOR_DELETE_SUCCESS
});

export const updateVendorApprovalStatusRequest = (payload) => ({
  type: UPDATE_VENDOR_APPROVAL_STATUS_REQUEST,
  payload
});

export const updateVendorApprovalStatusSuccess = (data) => ({
  type: UPDATE_VENDOR_APPROVAL_STATUS_SUCCESS,
  payload: data
});

export const updateVendorApprovalStatusFailure = (error) => ({
  type: UPDATE_VENDOR_APPROVAL_STATUS_FAILURE,
  payload: error
});

export const fetchCustomersByVendorRequest = (params) => ({
  type: FETCH_CUSTOMERS_BY_VENDOR_REQUEST,
  payload: { ...params }
});

export const fetchCustomersByVendorSuccess = (customers) => ({
  type: FETCH_CUSTOMERS_BY_VENDOR_SUCCESS,
  payload: customers
});

export const fetchCustomersByVendorFailure = (error) => ({
  type: FETCH_CUSTOMERS_BY_VENDOR_FAILURE,
  payload: error
});
